module.exports = __webpack_public_path__ + "img/appAsset-brand--Twilio.af2170c5.svg";